import React from 'react';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import { LinkButton } from 'com-gyf-webcore-userinterfacecomponents';

import CheckPermiso from './CheckPermiso.jsx';

const PanelBody = (props) => {
    let asignacionPerfilNodes = null;

    if (props.permiso.listaFunciones != undefined && props.permiso.listaFunciones.length > 0) {
        let checked;
        asignacionPerfilNodes = props.permiso.listaFunciones.map(function (funcion) {
            checked = props.permiso.funciones.find(x => x.id == funcion.id) != undefined;

            return (
                <CheckPermiso Id={funcion.id}
                    Description={funcion.descripcion}
                    PermisoId={props.permiso.id}
                    Key={funcion.id}
                    Checked={checked}
                    checkFuncion={props.checkFuncion} />
            );
        });
    } else {
        asignacionPerfilNodes = <GenericAlert message="Por favor, recuerde que debe seleccionar todos los campos antes de asignar las funciones." type="warning" />;
    }

    return (
        <div>
            <div className="row top-separator-xs">
                <div className="col-xs-3">
                    <h3 className="no-margin-bottom no-margin-top">...para:</h3>
                </div>
                <div className="col-xs-9">
                    {props.errorMessageFunciones &&
                        <label className="error zmdi-alert-circle no-margin-bottom">
                            {props.errorMessageFunciones}
                        </label>}
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="lnkbtn-divider divisor-section">
                                <LinkButton text="Todos" onClick={() => props.selectTodasFunciones(props.permiso.id)} class="lnkbtn-todos" /> |
                                <LinkButton text="Ninguno" onClick={() => props.unselectTodasFunciones(props.permiso.id)} class="lnkbtn-ninguno" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            {asignacionPerfilNodes}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PanelBody;